// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ellipse-container-mobile[data-v-6a6e2a52]{background:#f8f9f9;border-radius:50%;height:100vh;left:50%;overflow:hidden;position:absolute;transform:translateX(-50%) translateY(30%);width:200vw}.ellipse-child[data-v-6a6e2a52]{left:50%;position:absolute;transform:translateX(-50%);width:100vw}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
